export default "__VITE_ASSET__CSxOnc_O__"